import React from "react";
import suscripcionService from "../../_services/cart/suscripcion.service";
import facturacionService from "../../_services/cart/facturacion.service";
import { connect } from "react-redux";
import { isBrowser, isMobile } from "react-device-detect";
import { Link } from "react-router-dom";
import { history } from "../../_helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { userActions } from "../../_actions";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import authService from "../../_services/cart/authService";

class NavBarLateral extends React.Component {
  constructor(props) {
    super(props);
    this.toogleClasses = this.toogleClasses.bind(this);
    this.state = { active: true };
    this.state.active = !isMobile;
    this.wrapperRef = React.createRef();

    this.state.pathActual = history.location.pathname;

    history.listen((location, action) => {
      this.setState({ pathActual: location.pathname });
    });
  }

  cerrarSesion = () => {
    this.props.logout();
  };

  handleClose = () => this.setState({ show: false });
  handleShow = () => this.setState({ show: true });

  state = {
    pathActual: "",
  };

  toogleClasses(event) {
    this.setState((prevState) => {
      return { active: !this.state.active };
    });
  }

  esActual = (link) => link === this.state.pathActual;

  /**
   * Cada rol tiene su propia pantalla de perfil. Un admin que no vende caia en
   * la del comprador, que le hablaba de sus compras y no de su cuenta.
   */
  rutaMiPerfil = () => {
    if (authService.hasAuthority("VENDEDOR")) return "/vendedor/miPerfil";
    if (authService.hasAuthority("ADMIN")) return "/admin/miPerfil";
    return "/comprador/miPerfil";
  };

  miClase = (link) => {
    return this.esActual(link) ? "navbar__lateral-link--activa" : "";
  };

  /**
   * El menu del panel, agrupado por a quien le sirve cada pantalla.
   *
   * Antes era una lista plana con un `hasAuthority` por item: para un admin,
   * que ve las tres cosas, eran doce links seguidos sin ninguna separacion.
   * Las secciones vacias no se dibujan, asi que un comprador sigue viendo
   * exactamente lo mismo que antes.
   */
  secciones = () => {
    const esVendedor = authService.hasAuthority("VENDEDOR");
    const esAdmin = authService.hasAuthority("ADMIN");
    /* Un empleado de una cuenta ve solo los modulos de su rol. Para el dueño
       hasPermiso da siempre true. El back controla igual cada endpoint. */
    const puede = (permiso) => esVendedor && authService.hasPermiso(permiso);

    return [
      {
        titulo: "Mi cuenta",
        visible: authService.isAuthenticated(),
        items: [
          {
            to: "/comprador/misCompras",
            icono: "fa-solid fa-bag-shopping",
            texto: "Mis compras",
          },
          {
            /* La version con menu lateral: entrando por `/mensajes` el chat se
               dibuja con el header del sitio y sin el panel. Ver MensajesPanel. */
            to: "/perfil/mensajes",
            icono: "fa-solid fa-comments",
            texto: "Mensajes",
          },
          {
            to: "/perfil/alertas",
            icono: "fa-solid fa-bell",
            texto: "Mis alertas",
          },
          {
            /* Los usuarios y roles de la cuenta del vendedor (portado de
               tienda-admin, "Mi cuenta > Usuarios"). */
            to: "/vendedor/usuarios",
            icono: "fa-solid fa-user-group",
            texto: "Usuarios",
            visible: puede("USUARIOS"),
          },
          {
            to: "/vendedor/plan",
            icono: "fa-solid fa-award",
            texto: "Mi plan",
            visible: puede("MI_CUENTA"),
          },
          {
            /* Asistente de ARCA (portado de tienda-admin, Integraciones > ARCA). */
            to: "/vendedor/arca",
            icono: "fa-solid fa-file-invoice",
            texto: "Facturación ARCA",
            visible: puede("MI_CUENTA"),
          },
        ],
      },
      {
        titulo: "Vender",
        items: [
          {
            to: "/vendedor/dashboard",
            icono: "fa-solid fa-chart-line",
            texto: "Estadisticas",
            visible: puede("ESTADISTICAS"),
          },
          {
            to: "/vendedor/productos",
            icono: "fa-solid fa-tags",
            texto: "Mis publicaciones",
            visible: puede("PUBLICACIONES"),
          },
          {
            to: "/vendedor/ventas",
            icono: "fa-solid fa-receipt",
            texto: "Mis ventas",
            visible: puede("VENTAS"),
          },
          {
            to: "/vendedor/facturas",
            icono: "fa-solid fa-file-invoice-dollar",
            texto: "Facturas",
            visible: puede("FACTURACION") && !!this.state.facturacionHabilitada,
          },
          {
            /* Debajo de publicaciones y ventas a proposito: una oferta se carga
               sobre un catalogo que ya existe, asi que el orden del menu sigue al
               orden en que se usan las pantallas. */
            to: "/vendedor/ofertas",
            /* `fa-tags` ya lo usa "Mis publicaciones" un renglon mas arriba: dos
               entradas con el mismo icono se leen como la misma pantalla. */
            icono: "fa-solid fa-percent",
            texto: "Ofertas",
            visible: puede("OFERTAS"),
          },
          {
            /* La misma pantalla para vendedor y para admin: el que la mira
               quiere saber que se busca y no esta publicado. */
            to: "/vendedor/demanda",
            icono: "fa-solid fa-magnifying-glass-chart",
            texto: "Que estan buscando",
            visible: puede("ESTADISTICAS") || esAdmin,
          },
        ],
      },
      {
        titulo: "Administracion",
        items: [
          {
            to: "/admin/usuarios",
            icono: "fa-solid fa-users",
            texto: "Usuarios",
          },
          {
            to: "/admin/suscripciones",
            icono: "fa-solid fa-award",
            texto: "Suscripciones",
          },
          {
            to: "/admin/publicaciones",
            icono: "fa-solid fa-rectangle-list",
            texto: "Publicaciones",
          },
          {
            to: "/admin/ventas",
            icono: "fa-solid fa-file-invoice-dollar",
            texto: "Ventas",
          },
          {
            to: "/admin/consultas",
            icono: "fa-solid fa-envelope-open-text",
            texto: "Consultas",
          },
          {
            to: "/admin/tipos",
            icono: "fa-solid fa-sliders",
            texto: "Tipos de repuesto",
          },
        ],
        visible: esAdmin,
      },
    ]
      .filter((seccion) => seccion.visible !== false)
      .map((seccion) => ({
        ...seccion,
        items: seccion.items.filter((item) => item.visible !== false),
      }))
      .filter((seccion) => seccion.items.length > 0);
  };

  handleClickOutside = (event) => {
    if (
      this.wrapperRef &&
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(event.target)
    )
      this.setState({ active: false });
  };

  componentDidMount() {

    /* Los dias de prueba que quedan (o que la suscripcion no esta activa) se ven
       en todas las pantallas del panel, como en tienda-admin. El estado se
       cachea en el servicio, asi que navegar no lo vuelve a pedir. */
    if (authService.hasAuthority("VENDEDOR")) {
      suscripcionService
        .estado()
        .then((estado) => this.setState({ suscripcion: estado }))
        .catch(() => {});
      /* "Facturas" aparece recien con ARCA integrado y probado. */
      if (authService.hasPermiso("FACTURACION")) {
        facturacionService
          .habilitada()
          .then((h) => this.setState({ facturacionHabilitada: h }));
      }
    }

    let activeTheme = localStorage.getItem("theme");

    this.setState({dark: (activeTheme =='dark' || activeTheme == undefined)})
    if (activeTheme) {
      this.changeTheme(activeTheme);
    }else{
      this.changeTheme('dark');
    }

    document.addEventListener("mousedown", this.handleClickOutside);
  }

  changeTheme = (theme)=> {
    document.body.classList.add("theme-switch");
    if (theme === "system") {
      localStorage.removeItem("theme");
      document.body.removeAttribute("data-theme");
    } else {
      localStorage.setItem("theme", theme);
      document.body.setAttribute("data-theme", theme);
    }

    document.body.addEventListener(
      "transitionend",
      () => {
        document.body.classList.remove("theme-switch");
      },
      { once: true }
    );
  }

  /** El aviso de prueba gratis / suscripcion vencida, arriba del menu. */
  avisoSuscripcion = () => {
    const e = this.state?.suscripcion;
    if (!e || e.fundador) return null;
    if (e.vigente && e.trial) {
      return (
        <Link to="/planes" className="navbar__lateral-plan">
          <FontAwesomeIcon icon="fa-solid fa-gift" />
          <span>
            Prueba gratis: {e.diasRestantes} {e.diasRestantes === 1 ? "día" : "días"}
            <small>Elegí tu plan</small>
          </span>
        </Link>
      );
    }
    if (!e.vigente) {
      return (
        <Link to="/planes" className="navbar__lateral-plan navbar__lateral-plan--vencido">
          <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" />
          <span>
            {e.trial ? "Terminó tu prueba" : "Suscripción inactiva"}
            <small>Elegí un plan para publicar</small>
          </span>
        </Link>
      );
    }
    return null;
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  render() {
    const { user } = this.props;
    const secciones = this.secciones();
    const rutaMiPerfil = this.rutaMiPerfil();
    /* Con una sola seccion los titulos no separan nada: son ruido. */
    const conSecciones = secciones.length > 1;

    return (
      <>
      {/*
        `md` (768px) y no `xl`: de este ancho en adelante el Offcanvas deja de ser un
        panel deslizable y se dibuja inline, que es lo que hace de menu lateral fijo.
        Tiene que coincidir con el ancho en el que `.dashboard` le da su columna al
        sidenav (48em en _dashboard.scss). Con `xl` no coincidian: entre 720 y 1200px
        el grid ya reservaba la columna pero el contenido del menu seguia escondido en
        el panel, asi que quedaba una columna vacia con el logo y el boton de abrir
        flotando al lado del contenido. Si se cambia uno, hay que cambiar el otro.
      */}
      {["md"].map((expand) => (
      <div key={'navbarlat'} className="dashboard__sidenav">
        <Navbar
                        key={expand}
                        expand={expand}

                      >
        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-${expand}`}
          aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>{user.email}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="navbar__lateral">
              <div className="navbar__lateral-header d-sm-none d-md-block">
                <Link to={"/home"}>
                  <img
                    src={process.env.PUBLIC_URL + "/images/isologo-grey.png"}
                    width="100"
                    height="auto"
                    className="d-inline-block align-top"
                    alt="Logo"
                  />
                </Link>
                <h2 className="d-none">Deautopartes</h2>
              </div>

              <Link
                className="button navbar__lateral-volver"
                data-type="primary"
                to="/home"
              >
                <FontAwesomeIcon icon="fa-solid fa-arrow-left" />
                Volver al sitio
              </Link>

              {this.avisoSuscripcion()}

              <nav className="navbar__lateral-nav">
                {secciones.map((seccion) => (
                  <div className="navbar__lateral-seccion" key={seccion.titulo}>
                    {conSecciones && (
                      <h3 className="navbar__lateral-seccion-titulo">
                        {seccion.titulo}
                      </h3>
                    )}
                    <ul>
                      {seccion.items.map((item) => (
                        <li key={item.to}>
                          <Link
                            to={item.to}
                            className={
                              "navbar__lateral-link " + this.miClase(item.to)
                            }
                            aria-current={
                              this.esActual(item.to) ? "page" : undefined
                            }
                            onClick={(event) =>
                              !isBrowser && this.toogleClasses(event)
                            }
                          >
                            <FontAwesomeIcon icon={item.icono} fixedWidth />
                            <span>{item.texto}</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </nav>
              {/*
                "Mi perfil" y "Cerrar sesion" son dos acciones mas del menu.

                Antes vivian en una caja aparte con `accent-000` de fondo — un token
                que es claro en los DOS temas — asi que quedaba un recuadro crema con
                texto naranja pegado al pie, de otro color que todo el resto del menu.
                Y el logout era un icono solo, sin etiqueta.

                Ahora usan el mismo `-link` que cualquier entrada, y lo unico que los
                separa es la division de `-seccion`, igual que entre "Vender" y
                "Administracion". "Mi perfil" ademas queda marcado como activo cuando
                estas parado ahi, que antes no pasaba.

                Va afuera de `-nav` a proposito: ese bloque scrollea, y estas dos
                tienen que quedar siempre a la vista.
              */}
              <div className="navbar__lateral-seccion navbar__lateral-pie">
                <span className="navbar__lateral-cuenta" title={user.email}>
                  {user.email}
                </span>
                <ul>
                  <li>
                    <Link
                      to={rutaMiPerfil}
                      className={
                        "navbar__lateral-link " + this.miClase(rutaMiPerfil)
                      }
                      aria-current={
                        this.esActual(rutaMiPerfil) ? "page" : undefined
                      }
                      onClick={(event) =>
                        !isBrowser && this.toogleClasses(event)
                      }
                    >
                      <FontAwesomeIcon icon="fa-solid fa-circle-user" fixedWidth />
                      <span>Mi perfil</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={"/logout"}
                      className="navbar__lateral-link navbar__lateral-link--salir"
                    >
                      <FontAwesomeIcon
                        icon="fa-solid fa-arrow-right-from-bracket"
                        fixedWidth
                      />
                      <span>Cerrar sesión</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </Offcanvas.Body>
          </Navbar.Offcanvas>
          <Navbar>
          <Link to={"/home"}>
                  <img
                    src={process.env.PUBLIC_URL + "/images/isologo-grey.png"}
                    width="100"
                    height="auto"
                    className="d-inline-block align-top"
                    alt="Logo"
                  />
                </Link>
          </Navbar>
          {/*
            El hamburguesa que trae Bootstrap es un SVG de fondo con el color del
            trazo escrito adentro del data-uri (`rgba(33, 37, 41, .75)`), asi que
            sobre el fondo oscuro del panel quedaba negro sobre gris y no se veia
            que hubiera un boton — y no se puede repintar con una variable, porque
            el color esta dentro de la URL. Pasandole el icono como hijo, toma
            `currentColor` y sigue al tema.
          */}
          <Navbar.Toggle
            aria-controls={`offcanvasNavbar-expand-${expand}`}
            aria-label="Abrir el menú"
          >
            <FontAwesomeIcon icon="fa-solid fa-bars" size="lg" />
          </Navbar.Toggle>
          </Navbar>
      </div>
      ))}
      </>
    );
  }
}

function mapState(state) {
  const { user } = state.authentication;
  return { user };
}

const actionCreators = {
  logout: userActions.logout,
};

const connectedNavBarLateral = connect(mapState, actionCreators)(NavBarLateral);
export { connectedNavBarLateral as NavBarLateral };
